import React, { FunctionComponent } from 'react';
import { DealerLaunchStepProps } from '../types';
import { Dealer } from '../../../types/dealerTypes';
import { TextField } from '../../Input/TextField/TextField';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import styles from '../styles.module.scss';
import { emailValidatorFunction } from '../../../utils/validation';

export const DealerLaunchIntegrationADFEmail: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({ defaultValues: dealer });

  return (
    <DealerLaunchFormCardLayout
      form={form}
      title="How would you like to handle online leads?"
      subTitle="When customers enter Upstart Auto Retail from your website, we forward their info directly to your CRM. This is enabled when you provide an ADF email address that we can forward to."
      cardTitle="Where should we send your third party leads?"
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <div className={styles.stepRow}>
        <TextField
          label="ADF Email for New Cars"
          tooltip="Your CRM or IT department can provide this to you. This is the email address where all of your online leads are forwarded to so they can reach the CRM."
          name="crmEmailNew"
          form={form}
          validation={{ required: true, validate: emailValidatorFunction }}
          width="md"
        />
        <TextField
          label="ADF Email for Used Cars"
          tooltip="Your CRM or IT department can provide this to you. This is the email address where all of your online leads are forwarded to so they can reach the CRM."
          name="crmEmailUsed"
          form={form}
          validation={{ required: true, validate: emailValidatorFunction }}
          width="md"
        />
      </div>
    </DealerLaunchFormCardLayout>
  );
};
